const v2Router = [

  {
    path: '/data',
    name: 'data',
    component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/silkRoadV2Data'),
    redirect: '/data/SearchModule/Company',
    children: [
      {
        path: 'SearchModule',
        name: 'SearchModule',
        // redirect:'/data/SearchModule/Industry',
        component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/silkRoadV2Data/SearchModule'),
        meta: {
          tagV: "v2"
        },
        children: [
          {
            path: 'Company',
            name: 'Company',
            component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/silkRoadV2Data/Company'),
            meta: {
              tagV: "v2"
            }
          },
          {
            path: 'Industry',
            name: 'Industry',
            component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/silkRoadV2Data/Industry'),
            meta: {
              tagV: "v2"
            }
          },
          {
            path: 'Macro',
            name: 'Macro',
            component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/silkRoadV2Data/Macro'),
            meta: {
              tagV: "v2"
            }
          },
          {
            path: 'Transaction',
            name: 'Transaction',
            component: () => import(/* webpackChunkName: "SilkRoadData" */ '@/views/silkRoadV2Data/Transaction'),
            meta: {
              tagV: "v2"
            }
          }
        ]
      }
    ]
  }
];

export default v2Router